import { Controller } from 'stimulus';
import { primeForPostLogin, triggerCustomEvent } from 'lib/helpers';
import events from 'lib/events';

export default class FollowUserController extends Controller {
  static targets = [
    'textWrap',
  ];

  connect() {
    if (this.element.dataset.action !== 'follow-button#followAfterLogin') {
      this.element.addEventListener('ajax:success', this.updateButtonHref);
      this.element.addEventListener('ajax:error', this.updateButtonText);
    }
  }

  disconnect() {
    this.element.removeEventListener('ajax:success', this.updateButtonHref);
    this.element.removeEventListener('ajax:error', this.updateButtonText);
  }

  followAfterLogin = () => {
    primeForPostLogin('follow_after_login', this.element.dataset.userId);
    this.triggerfollow();
  }

  updateButtonText = () => {
    this.triggerGAEvents();
    if (this.hasTextWrapTarget) {
      const holdText = this.textWrapTarget.innerHTML;

      this.element.classList.toggle('is-following');
      this.element.classList.toggle('ez-btn--accent-light');

      this.textWrapTarget.innerHTML = this.element.dataset.switchText;
      this.element.dataset.switchText = holdText;
    }

    this.loadingButton();
  }

  updateButtonHref = () => {
    const holdHref = this.element.href;

    this.element.href = this.element.dataset.switchHref;
    this.element.dataset.switchHref = holdHref;

    this.loadingButton();
  }

  triggerfollow() {
    const username = this.getUsername();
    triggerCustomEvent(events.contributor.following, {
      category: 'follow',
      username,
    });
  }

  getUsername() {
    const usernameSelector = document.querySelector('.user-profile-layout');
    const showPageUsername = document.querySelector('.ez-resource-show__contributor');

    return usernameSelector?.getAttribute('data-profile-username') || showPageUsername?.getAttribute('data-contributor-name');
  }

  triggerGAEvents() {
    const username = this.getUsername();

    switch (this.element.dataset.switchText.trim()) {
      case 'Following':
        this.triggerfollow();
        break;
      case 'Follow':
        triggerCustomEvent(events.contributor.following, {
          category: 'unfollow',
          username,
        });
        break;
      default:
        break;
    }
  }

  loadingButton() {
    const buttonActiveClass = 'is-loading';

    if (this.element.dataset.action !== 'follow-button#followAfterLogin') {
      this.element.classList.toggle(buttonActiveClass);
    }
  }
}
